<div class="fwc-container sae-payment-information-body">
  <div class="fwc-row">
    <div class="fwc-col-12 payment-information-intro">
      <h2>{{content.sectionHead}}</h2>
    </div>
  </div>
</div>

<div class="fwc-container sae-payment-information-cards">
  <div class="fwc-row">
    <div class="fwc-col-12 fwc-card-generic flat card-container">
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12 payment-information-sub-intro">
          <h2>{{content.sectionSubHead}} @if (paymentInfo) {
            <span> $ {{paymentInfo?.premium}}</span>
          } </h2>
          @if (selectCoverage) {
            <div>
              Rate includes @if (!isMyAccount && !isMyAccountEnrol) {
              <span>Student +</span>
            }
            @if (paymentInfo) {
              <span> {{paymentInfo.dependents}} Dependent(s) for the</span>
            }
            {{paymentInfo?.termLabel}} Term, coverage {{formatDate($safeNavigationMigration(paymentInfo?.coverage_start))}} to
            {{formatDate($safeNavigationMigration(paymentInfo?.coverage_end))}}
          </div>
        }
      </div>
    </div>
    @if (!isMyAccount) {
      <div class="fwc-row fwc-row-bm ">
        <div class="fwc-col-12 ">
          <fwc-alert type="info" area="inline">{{content.alert}}</fwc-alert>
        </div>
      </div>
    }

    <form [formGroup]="paymentInformationForm" (ngSubmit)="onSubmitForm()">
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12">
          <h3>{{content.heading1}}</h3>
        </div>
      </div>

      <div class="fwc-row fwc-row-bm">

        <div class="fwc-col-3 sm-12 fwc-input ">
          <div class="fwc-flex">
            <label for="paymentType" class="label-w-tooltip">How Do You Want to Pay?</label>
            <fwc-tooltip icon term="email"
              message="For credit card payments, it is recommended to use a card issued in the US."
            class="label-tooltip"></fwc-tooltip>
          </div>
          <div class="fwc-select-list">
            <select name="paymentType" id="paymentType" formControlName="paymentType">
              <option value="" selected>Select a payment type</option>
              @for (payment of paymentTypes; track payment) {
                <option value="{{payment.key}}">{{payment.value}}
                </option>
              }
            </select>
            @if (form.paymentType.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please select a valid payment type</span>
            }
          </div>
        </div>
        @if (paymentInformationForm.value.paymentType == 'VISA' ||
        paymentInformationForm.value.paymentType == 'MASTERCARD' ||
        paymentInformationForm.value.paymentType == 'DISCOVERNETWORK' ||
        paymentInformationForm.value.paymentType == ''  ) {
          <div class="fwc-col-3 sm-12 fwc-input"
            >
            <label for="nameOnCard">Full Name on Card</label>
            <div class="sae-masked-input">
              <input name="nameOnCard" formControlName="nameOnCard" id="nameOnCard" type="text"
                pattern="^[A-Za-z- ']+$" maxlength="25" />
              @if (form.nameOnCard.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid full name</span>
              }
            </div>
          </div>
        }
        @if (paymentInformationForm.value.paymentType == 'VISA' ||
        paymentInformationForm.value.paymentType == 'MASTERCARD' ||
        paymentInformationForm.value.paymentType == 'DISCOVERNETWORK' ||
        paymentInformationForm.value.paymentType == '' ) {
          <div class="fwc-col-3 sm-12 fwc-input"
            >
            <label for="cardNumber">Card Number</label>
            <div class="sae-masked-input">
              <input name="cardNumber" formControlName="cardNumber" id="cardNumber" type="text"
                [minlength]="getCardMinLength()" pattern="[0-9-]+" [maxlength]="getCardMaxLength()" (change)="encryptCard()" />
              @if (form.cardNumber.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid card number</span>
              }
            </div>
          </div>
        }

        <!-- If the user selects payment type as Checking Account -->
        @if (paymentInformationForm.value.paymentType != 'VISA' &&
        paymentInformationForm.value.paymentType != 'MASTERCARD' &&
        paymentInformationForm.value.paymentType != 'DISCOVERNETWORK' &&
        paymentInformationForm.value.paymentType != '' ) {
          <div class="fwc-col-3 sm-12 fwc-input"
            >
            <label for="fullName">Full Name</label>
            <div class="sae-masked-input">
              <input name="fullName" formControlName="fullName" id="fullName" type="text"
                pattern="^[A-Za-z- ']+$" maxlength="25" />
              @if (form.fullName.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid full name</span>
              }
            </div>
          </div>
        }
        @if (paymentInformationForm.value.paymentType != 'VISA' &&
        paymentInformationForm.value.paymentType != 'MASTERCARD' &&
        paymentInformationForm.value.paymentType != 'DISCOVERNETWORK' &&
        paymentInformationForm.value.paymentType != '' ) {
          <div class="fwc-col-3 sm-12 fwc-input"
            >
            <label for="bankName">Bank Name</label>
            <div class="sae-masked-input">
              <input name="bankName" formControlName="bankName" id="bankName" type="text"
                pattern="^[A-Za-z- ']+$" maxlength="255" />
              @if (form.bankName.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid bank name</span>
              }
            </div>
          </div>
        }

      </div>

      @if (paymentInformationForm.value.paymentType == 'VISA' ||
      paymentInformationForm.value.paymentType == 'MASTERCARD' ||
      paymentInformationForm.value.paymentType == 'DISCOVERNETWORK' ||
      paymentInformationForm.value.paymentType == ''   ) {
        <div class="fwc-row fwc-row-bm"
          >
          <div class="fwc-col-3 sm-12">
            <div class="fwc-select-list">
              <label for="expirationMonth">Expiration Date</label>
              <select name="expirationMonth" id="expirationMonth" formControlName="expirationMonth">
                <option value="" selected>Month</option>
                @for (month of months; track month) {
                  <option value="{{month.key}}">{{month.value}}</option>
                }
              </select>
              @if (form.expirationMonth.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please select a valid expiration month</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12">
            <div class="fwc-select-list">
              <label for="expirationYear">Expiration Year</label>
              <select name="expirationYear" id="expirationYear" formControlName="expirationYear">
                <option value="" selected>Year</option>
                @for (year of currentYear; track year) {
                  <option value="{{year}}">{{year}}</option>
                }
              </select>
              @if (form.expirationYear.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please select a valid expiration year</span>
              }
            </div>
          </div>
        </div>
      }

      <!-- If the user selects payment type as Checking Account -->
      @if (paymentInformationForm.value.paymentType != 'VISA' &&
      paymentInformationForm.value.paymentType != 'MASTERCARD' &&
      paymentInformationForm.value.paymentType != 'DISCOVERNETWORK' &&
      paymentInformationForm.value.paymentType != '' ) {
        <div class="fwc-row fwc-row-bm"
          >
          <div class="fwc-col-3 sm-12 fwc-input ">
            <label for="routingNumber">Routing Number</label>
            <div class="sae-masked-input">
              <input name="routingNumber" formControlName="routingNumber" id="routingNumber" type="text"
                minlength="9" pattern="[0-9-]+" maxlength="9" />
              @if (form.routingNumber.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid routing number</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12 fwc-input ">
            <label for="accountNumber">Account Number</label>
            <div class="sae-masked-input">
              <input name="accountNumber" formControlName="accountNumber" id="accountNumber" type="text"
                minlength="4" pattern="[0-9-]+" maxlength="17" />
              @if (form.accountNumber.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid account number</span>
              }
            </div>
          </div>
          <div class=" fwc-col-5 sm-12">
            <img src="assets/images/CheckImage.png" alt="">
            <div class="top-xxs">
              <p>
                This example shows where you can find your routing number and account number for your
                checking account.
              </p>
            </div>
          </div>
        </div>
      }

      <div>
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-12 fwc-flex">
            <h3>{{content.heading2}} </h3>
            <div class="fwc-checkbox left-xxs">
              <input type="checkbox" name="sameAddress" id="sameAddress" value="true"
                (click)="setAddress($event)" (keydown.enter)="$event.target.click()" />
              <label for="sameAddress">Same as my mailing address</label>
            </div>
          </div>
        </div>

        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="billingAddress">Billing Address</label>
            <div class="sae-masked-input">
              <input name="billingAddress" formControlName="billingAddress" id="billingAddress"
                type="text" maxlength="255" />
              @if (form.billingAddress.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid billing address</span>
              }
            </div>
          </div>

          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="suite_apt">Suite/Apt# <span class="optionalFeild-design">
            Optional</span></label>
            <div class="sae-masked-input">
              <input name="suite_apt" formControlName="suite_apt" id="suite_apt" type="text" maxlength="255" />
            </div>
          </div>

        </div>


        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-3 sm-12 fwc-input">
            <label for="billingCity">Billing City</label>
            <div class="sae-masked-input">
              <input name="billingCity" formControlName="billingCity" id="billingCity" type="text"
                pattern="^[A-Za-z ]+$" maxlength="25" />
              @if (form.billingCity.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please enter a valid billing city</span>
              }
            </div>
          </div>
          <div class="fwc-col-3 sm-12">
            <div class="fwc-select-list">
              <label for="billingState">Billing State</label>
              <select name="billingState" id="billingState" formControlName="billingState">
                @if (paymentInformationForm.value.billingState != 'null') {
                  <option value="" selected
                    >Select state
                  </option>
                }
                @if (paymentInformationForm.value.stabillingStatete == 'null') {
                  <option value="null" selected
                    >Select state
                  </option>
                }
                @for (state of statesData; track state) {
                  <option value="{{state.key}}">{{state.value}}
                  </option>
                }
              </select>
              @if (form.billingState.errors && formSubmitted) {
                <span role="alert"
                class="fwc-inline-icon fwc-icon-delete">Please select a valid billing state</span>
              }
            </div>
          </div>


          <div class="fwc-col-3 sm-12 fwc-input fwc-input-icon">
            <label for="billingZipCode">Billing Zip Code</label>
            <div class="sae-masked-input">
              <span class="sae-icon"> <img src="assets/images/location-pin.png" alt=""> </span>
              <input name="billingZipCode" formControlName="billingZipCode" id="billingZipCode"
                placeholder="ZIP Code" type="text" pattern="[0-9]+" minlength="5" maxlength="5" />
            </div>
            @if (form.billingZipCode.errors && formSubmitted) {
              <span role="alert"
              class="fwc-inline-icon fwc-icon-delete">Please enter a valid billing zip code</span>
            }
          </div>

          <!-- <div class="fwc-col-3 sm-12">
          <div class="fwc-input fwc-input-icon">
            <label for="billingZipCode">Billing Zip Code</label>
            <span class="fwc-icon location-pin">
              <img src="assets/images/location-pin.png" alt="">
            </span>
            <input name="billingZipCode" formControlName="billingZipCode" id="billingZipCode"
              placeholder="ZIP Code" type="text" pattern="[0-9]+" minlength="4" maxlength="10" />
            <span role="alert" *ngIf="form.billingZipCode.errors && formSubmitted"
            class="fwc-inline-icon fwc-icon-delete">Please enter a valid billing zip code</span>
          </div>
        </div> -->

      </div>
    </div>

  </form>

  @if (!isMyAccount) {
    <div class="fwc-row">
      <div class="fwc-col-12 fwc-divider">
      </div>
    </div>
  }

  @if (!isMyAccount) {
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-12">
        <h3>{{content.terms.heading}}</h3>
        <p class="gray-font top-xs">{{content.terms.content}}</p>
      </div>
    </div>
  }

  @if (!isMyAccount) {
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-12 disclosure-container">
        <div class="fwc-checkbox">
          <input type="checkbox" name="disclosureCheckbox" id="disclosureCheckbox" value="true"
            [(ngModel)]="paymentInformationAgreement" (keydown.enter)="paymentInformationAgreement = !paymentInformationAgreement" />
          <label for="disclosureCheckbox"><strong>{{content.terms.aggrement}}</strong></label>
        </div>
      </div>
    </div>
  }

</div>
</div>
</div>